<template>
<section class="home-hero" :class="{ fixed: this.isFixed }">
  <transition :name="getHeroTransition()" :duration="{ enter: 2000, leave: 500 }" mode="out-in">
    <HeroTrack
      :data="track"
      :tracks="tracks"
      :current="current"
      :index="index"
      v-if="current == track._id"
      v-for="(track, index) in tracks"
      v-bind:key="track._id"
      @changeTrack="changeTrack"
      @prevTrack="prevTrack"
      @nextTrack="nextTrack"
      />
  </transition>
</section>
</template>

<script>
import HeroTrack from '@/pages/home/Hero/Track'
import { TweenMax } from 'gsap'
import 'gsap/ScrollToPlugin'

export default {
  name: 'HomeHero',
  dependencies: ['DATA'],
  data () {
    return {
      current: null,
      timer: null,
      x: null,
      y: null,
      currentIndex: 0,
      isFixed: false,
      transition: "left"
    }
  },
  components: {
    HeroTrack
  },
  computed: {
    tracks () {
      return (this.DATA) ? this.DATA['home_hero'] : []
    }
  },
  methods: {
    getHeroTransition() {
      return this.transition
    },
    changeTrack (track) {
      this.current = track
    },
    setCurrent (id) {
      this.current = id
      this.autoNext()
      setTimeout(() => {
        this.$bus.$emit('updateColors')
      }, 0)
    },
    getTrackIndex (id) {
      id = id || this.current
      for (var i in this.tracks) {
        if (this.tracks[i]._id === id) {
          return parseInt(i)
        }
      }
    },
    nextTrack () {
      this.transition = "slide-right-hero"
      let currentIndex = this.getTrackIndex()
      if (currentIndex === (this.tracks.length - 1)) {
        this.setCurrent(this.tracks[0]._id)
      } else {
        this.setCurrent(this.tracks[currentIndex + 1]._id)
      }
    },
    prevTrack () {
      this.transition = "slide-right-hero"
      let currentIndex = this.getTrackIndex()
      if (currentIndex === 0) {
        this.setCurrent(this.tracks[this.tracks.length - 1]._id)
      } else {
        this.setCurrent(this.tracks[currentIndex - 1]._id)
      }
    },
    checkKey (e) {
      if (e.keyCode === 37) {
        this.prevTrack()
      } else if (e.keyCode === 39) {
        this.nextTrack()
      }
    },
    autoNext () {
      // if (this.timer) {
      //   clearTimeout(this.timer)
      // }
      // this.timer = setTimeout(() => {
      //   this.nextTrack()
      // }, 10000)
    },
    handleTouchStart (evt) {
      this.x = evt.touches[0].clientX
      this.y = evt.touches[0].clientY
    },
    handleTouchMove (evt) {
      if (!this.x && !this.y) {
        return
      }
      let xUp = evt.touches[0].clientX
      let yUp = evt.touches[0].clientX
      let xDiff = this.x - xUp
      let yDiff = this.y - yUp
      if (Math.abs(xDiff) > (Math.abs(yDiff) - 200)) {
        if (xDiff > 0) {
          this.prevTrack()
        } else {
          this.nextTrack()
        }
      }
      this.x = null
      this.y = null
    }
  },
  destroyed () {
    document.removeEventListener('keydown', this.checkKey)
    document.removeEventListener('touchstart', this.handleTouchStart)
    document.removeEventListener('touchmove', this.handleTouchMove)
    this.$bus.$off('holdScreen')
    this.$bus.$off('releaseScreen')
  },
  mounted () {
    if (!this.current && this.tracks.length) {
      this.setCurrent(this.tracks[0]._id)
    }
    document.addEventListener('keydown', this.checkKey, false)
    document.addEventListener('touchstart', this.handleTouchStart, false)
    document.addEventListener('touchmove', this.handleTouchMove, false)
    this.$bus.$on('holdScreen', () => { 
      this.isFixed = true; 
      TweenMax.set(this.$el, { y: -window.LAST_SCROLL_Y });
      TweenMax.to(window, 0.5, { scrollTo: {y : 0}});
    })
    this.$bus.$on('releaseScreen', () => { 
      this.isFixed = false;
      TweenMax.set(this.$el, { y: 0 })
      TweenMax.set(document.body, { opacity: 0 })
      TweenMax.set(window, { scrollTo: { y: window.LAST_SCROLL_Y }, delay:0.1});
      TweenMax.to(document.body, 0.5, { opacity: 1, delay: 0.5});
    })
  }
}
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/easing';
.home-hero {
    position: relative;
    height: 100vh;
    @media screen and (max-width: 64em) and (orientation:portrait) {
      height: 60vh;
    }

    &.fixed {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100vh;
    }
}

  /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-right-hero-enter-active {
  transition: all 2s $easeOutQuint;
  filter: brightness(0%);
  .background {
    transition: all 2s $easeOutQuint;
    transform: translateY(30px);
    filter: brightness(0%);
  }
  .home-hero-track {
    transition: all 2s $easeOutQuint;
    opacity: 0;
  }
  .circle {
    transition: all 2.4s $easeOutQuint;
    transform: scale(0.9) translate3d(0px, 100px, 0px);
    opacity: 0;    
  }
}
.slide-right-hero-leave-active {
  transition: all 0.5s $easeOutQuint;
  .background {
    transition: all 0.5s $easeOutQuint;
  }
}
.slide-right-hero-leave-to {
  filter: brightness(0%);
  .background {
    transform: translateX(0px);
    filter: brightness(0%);
  }
}
.slide-right-hero-enter-to {
  filter: brightness(100%);
  .background {
    transform: translateY(0px);
    filter: brightness(100%);
  }
  .circle {
    transform: scale(1) translate3d(0px, 0px, 0px);
    opacity: 1;
  }  
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Hero/index.vue